import Util from '@/service/Util'
import http from '../http'

export default {
  createRoll(data) {
    return http({
      method: 'POST',
      url: '/kcengine-ws-rest/rolls',
      data,
      roles: ['ROLE_ROLL_CREATOR']
    })
  },

  getCodeConfiguration(id) {
    return http({
      method: 'GET',
      url: `/administration/v1/code-configurations/${id}`,
    })
  },

  getCodeConfigurations(req) {
    return http({
      method: 'GET',
      url: '/administration/v1/code-configurations',
      params: req
    })
  },

  getRollDetails(rollId) {
    return http({
      method: 'GET',
      url: `/rolls/v1/${rollId}/details`,
      roles: ['ROLE_ROLL_VIEWER']
    })
  },

  listOrderRolls(orderId, req) {
    return http({
      method: 'GET',
      url: `/serialization/v2/order/${orderId}/rolls`,
      params: req,
      roles: ['ROLE_ROLL_VIEWER']
    })
  },

  getRollStats(orderId) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/order/${orderId}/rollsstats`,
      roles: ['ROLE_ROLL_VIEWER']
    })
  },

  simulateValidation(params) {
    return http({
      method: 'GET',
      url: '/validationsim',
      params,
      roles: ['ROLE_SECTION_MANAGER', 'ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
    })
  },

  getAllValidations(req) {
    return http({
      data: req,
      method: 'POST',
      url: '/kcengine-ws-rest/validations',
      roles: ['ROLE_VALIDATION_LOG_VIEWER']
    })
  },

  createExpansion(id, data) {
    return http({
      method: 'POST',
      url: `/serialization/v2/orders/${id}/expansions`,
      data,
      headers: { 'X-RequestId': Util.createUniqueXRequestId() },
      roles: ['ROLE_CODE_MANAGER']
    })
  },

  listOrderExpansions(orderId, params) {
    return http({
      method: 'GET',
      url: `/serialization/v1/orders/${orderId}/expansions`,
      params,
      roles: ['ROLE_CODE_MANAGER']
    })
  },

  uploadCodestatusFile(failOnInvalid, data) {
    const fail = failOnInvalid ? '?failOnInvalid=true' : ''
    return http({
      method: 'POST',
      url: `/kcengine-ws-rest/codes/statuses/${fail}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data,
      roles: ['ROLE_CODE_STATUS_MANAGER']
    })
  },

  overviewStatistics(data) {
    return http.post('/kcengine-ws-rest/statistics', data)
  },

  getLastOrdersStatistics() {
    return http.get('/kcengine-ws-rest/statistics/lastorders')
  },

  getLastOrderExpansions() {
    return http.get('/kcengine-ws-rest/statistics/lastexpansions')
  },

  listAuditTrail(data) {
    return http({
      method: 'POST',
      url: '/common-ws-rest/audittrail/list',
      data,
      roles: ['ROLE_ADMIN']
    })
  },

  clearPersistenceCache() {
    return http({
      method: 'DELETE',
      url: '/system/jpal2cache',
      data: {},
      roles: ['ROLE_ADMIN']
    })
  },
  clearCache(cacheName) {
    return http({
      method: 'DELETE',
      url: `/system/caches/v1/${cacheName}`,
      roles: ['ROLE_ADMIN']
    })
  },

  listCaches() {
    return http({
      method: 'GET',
      url: '/system/caches/v1',
      params: { page: 0, size: 1000 },
      roles: ['ROLE_ADMIN']
    })
  },

  serializationStatistics(req) {
    return http({
      method: 'GET',
      url: '/serialization/statistics/v1/production',
      params: req,
      roles: ['ROLE_ORGANIZATION_ADMIN']
    })
  },

  addCodeConfigToChannel(channelId, configId) {
    return http({
      method: 'POST',
      url: `/channel/v1/${channelId}/codeconfig/${configId}`,
      roles: ['ROLE_ADMIN', 'ROLE_SUPPORT']
    })
  },

  unassignCodeConfigFromChannel(channelId) {
    return http({
      method: 'DELETE',
      url: `/channel/v1/channels/${channelId}/codeconfig`,
      roles: ['ROLE_ADMIN', 'ROLE_SUPPORT']
    })
  },

  createProductMetadataSchema(name, data) {
    return http({
      url: `/kcengine-ws-rest/products/metadataschema/${name}`,
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      data,
      roles: ['ROLE_METADATA_SCHEMA_MANAGER']
    })
  },

  getProductMetadataSchema(name) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/products/metadataschema/${name}`,
      roles: ['ROLE_METADATA_SCHEMA_MANAGER', 'ROLE_METADATA_MANAGER', 'ROLE_METADATA_SCHEMA_READER']
    })
  },

  deleteProductSchema(name) {
    return http({
      url: '/kcengine-ws-rest/product/metadataschemas',
      method: 'DELETE',
      data: { name },
      roles: ['ROLE_METADATA_SCHEMA_MANAGER']
    })
  },

  updateGeofence(data) {
    return http({
      method: 'PUT',
      url: `/geofence/v1/geofences/${data.id}`,
      data,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  createGeofence(data) {
    return http({
      method: 'POST',
      url: '/geofence/v1/geofences',
      data,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  findGeolocationByCoordinates(c) {
    return http.get('/geolocation/v1/locations/coordinates', { params: c })
  },

  findPreviewBoundary(locationId, minLng, maxLng, minLat, maxLat, h, w) {
    return http.get(`/geolocation/v1/locations/${locationId}/previewboundaries?minLng=${minLng}&maxLng=${maxLng}&minLat=${minLat}&maxLat=${maxLat}&height=${h}&width=${w}`)
  },

  findBoundary(locationId) {
    return http.get(`/geolocation/v1/locations/${locationId}/boundary`)
  },

  retreiveGeofenceFailedValidations(id) {
    return http({
      method: 'GET',
      url: `/geofence/v1/geofences/${id}/validations`,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  loadGeofenceBySectionId(id) {
    return http({
      method: 'GET',
      url: `/geofence/v1/geofences/section/${id}`,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  loadGeofenceByOrderId(id) {
    return http({
      method: 'GET',
      url: `/geofence/v1/geofences/order/${id}`,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  listChildLocations(id) {
    return http.get(`/geolocation/v1/locations/${id}/children`, { params: { page: 0, size: 1000 } })
  },

  listCountries(code) {
    return http.get(`/geolocation/v1/continents/${code}/countries`)
  },

  listContinents() {
    return http.get('/geolocation/v1/continents')
  },

  saveAti(data) {
    return http({
      method: 'POST',
      url: '/kcengine-ws-rest/atis',
      data,
      roles: ['ROLE_ATI_MANAGER', 'ROLE_SECTION_ACTIVATOR']
    })
  },

  updateAti(id, data) {
    return http({
      method: 'PUT',
      url: `/kcengine-ws-rest/atis/${id}`,
      data,
      roles: ['ROLE_ATI_MANAGER']
    })
  },

  removeAti(id) {
    return http({
      method: 'delete',
      url: `/kcengine-ws-rest/atis/${id}`,
      data: { id },
      roles: ['ROLE_ATI_MANAGER']
    })
  },

  readAti(id) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/atis/${id}`,
      roles: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
    })
  },

  listAtisBySectionId(sectionId) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/sections/${sectionId}/atis`,
      roles: ['ROLE_SECTION_MANAGER', 'ROLE_SECTION_ACTIVATOR']
    })
  },

  unlinkAti(sectionId, atiId) {
    const data = { sectionId, id: atiId }
    return http({
      method: 'DELETE',
      url: `/kcengine-ws-rest/sections/${sectionId}/atis/${atiId}`,
      data,
      roles: ['ROLE_SECTION_MANAGER']
    })
  },

  applyAtiGroup(sectionId, atiGroupId) {
    const data = { sectionId, atiGroupId }
    return http({
      method: 'PUT',
      url: `/kcengine-ws-rest/sections/${sectionId}/atigroup/${atiGroupId}`,
      data
    })
  },

  applyAti(sectionId, atiId) {
    const data = { sectionId, id: atiId }
    return http({
      method: 'PUT',
      url: `/kcengine-ws-rest/sections/${sectionId}/atis/${atiId}`,
      data,
      roles: ['ROLE_SECTION_MANAGER']
    })
  },

  listAtis(params) {
    return http({
      method: 'GET',
      url: '/kcengine-ws-rest/atis',
      params,
      roles: ['ROLE_ATI_VIEWER', 'ROLE_SECTION_ACTIVATOR', 'ROLE_SECTION_MANAGER', 'ROLE_ORGANIZATION_ADMIN', 'ROLE_ATI_MANAGER']
    })
  },

  listAtiGroups(params) {
    return http({
      method: 'GET',
      url: '/kcengine-ws-rest/atigroups',
      params,
      roles: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER', 'ROLE_SECTION_MANAGER']
    })
  },

  getAtiGroup(id) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/atigroups/${id}`,
      roles: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
    })
  },

  getAti(id) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/atis/${id}`,
      roles: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
    })
  },

  createAtiGroup(data) {
    return http.post('/kcengine-ws-rest/atigroups', data)
  },

  updateAtiGroup(id, data) {
    return http.put(`/kcengine-ws-rest/atigroups/${id}`, data)
  },

  removeAtiGroup(id) {
    return http({
      method: 'DELETE',
      url: `/kcengine-ws-rest/atigroups/${id}`,
      data: { id },
      roles: ['ROLE_ATI_MANAGER']
    })
  },

  listOrders(params) {
    return http({
      method: 'GET',
      url: 'serialization/v1/orders',
      params,
      roles: ['ROLE_ORDER_MANAGER', 'ROLE_CODE_MANAGER']
    })
  },

  getOrder(id) {
    return http({
      method: 'GET',
      url: `/serialization/v2/orders/${id}`,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  updateOrder(id, data) {
    return http({
      method: 'PUT',
      url: `/kcengine-ws-rest/order/${id}`,
      data,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  lockOrder(id, data) {
    return http({
      method: 'PUT',
      url: `/kcengine-ws-rest/order/${id}/lock`,
      data,
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  moveOrder(orderId, data) {
    return http({
      method: 'PUT',
      url: `/serialization/v1/orders/${orderId}/organization`,
      data,
      roles: ['ROLE_RUNAS']
    })
  },

  getOrderValidations(id) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/order/${id}/validations`,
      roles: ['ROLE_ORDER_STATISTICS_VIEWER']
    })
  },

  recallOrder(id) {
    return http({
      method: 'POST',
      url: `/recalls/v1/analysis/order/${id}`,
      roles: ['ROLE_RECALL_MANAGER']
    })
  },

  getRecallsInOrder(id) {
    return http({
      method: 'GET',
      url: `/recalls/v1/order/${id}`,
      roles: ['ROLE_RECALL_MANAGER']
    })
  },

  listSectionsInOrder(orderId, req) {
    return http({
      method: 'GET',
      url: `/serialization/v1/sections/order/${orderId}`,
      params: req,
      roles: ['ROLE_SECTION_MANAGER']
    })
  },

  deleteOrderSectionMetadata(orderId, sectionId) {
    return http({
      method: 'DELETE',
      url: `/kcengine-ws-rest/order/${orderId}/section/${sectionId}/metadata.json`,
      roles: ['ROLE_METADATA_MANAGER', 'ROLE_SECTION_MANAGER']
    })
  },

  deleteOrderMetadata(orderId) {
    return http({
      method: 'DELETE',
      url: `/kcengine-ws-rest/order/${orderId}/metadata.json`,
      roles: ['ROLE_METADATA_MANAGER']
    })
  },

  getCodeByIndex(id, req) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/orders/${id}/codes`,
      params: req,
      roles: ['ROLE_CODE_DOWNLOADER']
    })
  },

  createSection(data) {
    return http({
      method: 'POST',
      url: '/kcengine-ws-rest/sections',
      data,
      roles: ['ROLE_SECTION_MANAGER']
    })
  },

  deleteSection(id) {
    return http({
      method: 'DELETE',
      url: `/kcengine-ws-rest/sections/${id}`,
      data: { sectionId: id },
      roles: ['ROLE_SECTION_MANAGER']
    })
  },

  getSection(sectionId) {
    return http({
      method: 'GET',
      url: `/serialization/v1/sections/${sectionId}`,
      roles: ['ROLE_SECTION_MANAGER', 'ROLE_SECTION_ACTIVATOR']
    })
  },

  updateSection(id, data) {
    return http({
      method: 'PUT',
      url: `/kcengine-ws-rest/sections/${id}`,
      data,
      roles: ['ROLE_SECTION_MANAGER', 'ROLE_SECTION_ACTIVATOR']
    })
  },

  recallSection(id) {
    return http({
      method: 'POST',
      url: `/recalls/v1/analysis/section/${id}`,
      roles: ['ROLE_RECALL_MANAGER']
    })
  },

  listRecallsInSection(id) {
    return http({
      method: 'GET',
      url: `/recalls/v1/section/${id}`,
      roles: ['ROLE_RECALL_MANAGER']
    })
  },

  codesBlacklistRemove(codes) {
    return http({
      method: 'DELETE',
      url: '/kcengine-ws-rest/codeblacklist',
      data: { codes: codes.join(',') },
      roles: ['ROLE_ADMIN']
    })
  },

  codesBlacklistAdd(codes) {
    return http({
      method: 'POST',
      url: '/kcengine-ws-rest/codeblacklist',
      data: { codes: codes.join(',') },
      roles: ['ROLE_ADMIN']
    })
  },

  codesBlacklist() {
    return http({
      method: 'GET',
      url: '/kcengine-ws-rest/codeblacklist',
      roles: ['ROLE_ADMIN']
    })
  },

  listProductMetadataSchemas(params) {
    return http.get('/kcengine-ws-rest/product/metadataschemas', { params })
  },

  createOrder(data) {
    return http({
      method: 'POST',
      url: '/serialization/v1/orders',
      data,
      headers: { 'X-RequestId': Util.createUniqueXRequestId() },
      roles: ['ROLE_ORDER_MANAGER']
    })
  },

  findCode(orderId, codeIndex) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/orders/${orderId}/codes`,
      params: {
        max: 1,
        offset: codeIndex,
        orderId
      },
      roles: ['ROLE_CODE_DOWNLOADER']
    }).then((resp) => resp.data.codes[0])
  },

  codeInfo(code) {
    return http({
      method: 'GET',
      url: `/serialization/v1/codeinfo/${code}`,
      roles: ['ROLE_CODE_DISSECTOR']
    })
  },

  createCodeConfig(data) {
    return http({
      method: 'POST',
      url: '/administration/v1/code-configurations',
      data,
      headers: { 'X-RequestId': Util.createUniqueXRequestId() },
    })
  },

  batchValidate(data, params) {
    return http({
      method: 'POST',
      url: '/code-authentication/v2/batch',
      data,
      params
    })
  },

  proxyCodeValidator(data) {
    return http({
      method: 'POST',
      url: '/code-authentication/v1/proxy',
      data,
      roles: ['ROLE_EXTERNAL_CODE_VALIDATOR']
    })
  },

  listCodeConfigs(req) {
    return http({
      method: 'GET',
      url: '/serialization/v1/code-configurations',
      params: req,
      roles: ['ROLE_CODE_MANAGER']
    })
  },

  getCodeConfig(id) {
    return http.get(`/administration/v1/code-configurations/${id}`)
  },

  listEntryChannels(params) {
    return http({
      method: 'GET',
      url: '/kcengine-ws-rest/entrychannels',
      params
    })
  },

  listEntryChannelsV2(params) { // TODO: Replace "listEntryChannels" when all data is present here as well, missing property Owner and Translations
    return http({
      method: 'GET',
      url: '/channel/v1/channels',
      params,
      roles: ['ROLE_ADMIN', 'ROLE_SUPPORT', 'ROLE_PRODUCT_MANAGER']
    })
  },

  getEntryChannel(id) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/entrychannels/${id}`,
      roles: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
    })
  },

  createEntryChannel(data) {
    return http({
      method: 'POST',
      url: '/kcengine-ws-rest/entrychannels',
      data,
      roles: ['ROLE_ADMIN']
    })
  },

  updateEntryChannel(data) {
    return http({
      method: 'PUT',
      url: '/kcengine-ws-rest/entrychannels',
      data,
      roles: ['ROLE_ADMIN']
    })
  },

  deleteEntryChannel(id) {
    return http({
      method: 'DELETE',
      url: `/kcengine-ws-rest/entrychannels/${id}`,
      data: { id }
    })
  },

  getMetadataSchemas(params) {
    return http({
      method: 'GET',
      url: '/kcengine-ws-rest/metadataschemas',
      params,
      roles: ['ROLE_SECTION_ACTIVATOR', 'ROLE_METADATA_SCHEMA_MANAGER', 'ROLE_METADATA_SCHEMA_READER', 'ROLE_SECTION_ACTIVATOR']
    })
  },

  createMetadataSchema(name, data) {
    return http({
      url: `/kcengine-ws-rest/metadataschema/${name}`,
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      data,
      roles: ['ROLE_METADATA_SCHEMA_MANAGER']
    })
  },

  setDefaultMetadataSchema(name) {
    return http.put('/kcengine-ws-rest/metadataschemas/default', name)
  },

  deleteMetadataSchema(name) {
    return http({
      method: 'DELETE',
      url: `/kcengine-ws-rest/metadataschemas/${name}`,
      data: { name },
      roles: ['ROLE_METADATA_SCHEMA_MANAGER']
    })
  },

  listCodeStatuses() {
    return http({
      method: 'GET',
      url: '/kcengine-ws-rest/codestatusconfig',
      roles: ['ROLE_USER']
    })
  },

  setCodeStatus(data) {
    return http({
      method: 'POST',
      url: '/kcengine-ws-rest/codestatuses',
      data,
      roles: ['ROLE_CODE_STATUS_MANAGER']
    })
  },
  getCodeStatus(id) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/codestatusconfig/${id}`,
      roles: ['ROLE_CODE_STATUS_CONFIG_MANAGER']
    })
  },

  createCodeStatus(data) {
    return http({
      method: 'POST',
      url: '/kcengine-ws-rest/codestatusconfig',
      data,
      roles: ['ROLE_CODE_STATUS_CONFIG_MANAGER']
    })
  },

  updateCodeStatus(data) {
    return http({
      method: 'PUT',
      url: '/kcengine-ws-rest/codestatusconfig',
      data,
      roles: ['ROLE_CODE_STATUS_CONFIG_MANAGER']
    })
  },

  getCodeBundle(orderId, codeIndex) {
    return http({
      method: 'GET',
      url: `/serialization/v1/codes/${orderId}/${codeIndex}`
    })
  },

  getOrderCodeStatusStatistics(orderId) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/order/${orderId}/statistics`,
      roles: ['ROLE_ORDER_STATISTICS_VIEWER']
    })
  },

  getSchemaById(id) {
    return http({
      method: 'GET',
      url: `/serialization/v1/metadataschemas/${id}`
      // roles: ?
    })
  },
  saveOrderMetadata(orderId, data) {
    return http.post(`/kcengine-ws-rest/order/${orderId}/metadata.json`, data)
  },
  saveSectionMetadata(orderId, sectionId, data) {
    return http.post(`/kcengine-ws-rest/order/${orderId}/section/${sectionId}/metadata.json`, data)
  },
  getProductMetadata(id) {
    return http({
      method: 'GET',
      url: `/kcengine-ws-rest/products/${id}/metadata.json`,
      roles: ['ROLE_PRODUCT_MANAGER', 'ROLE_PRODUCT_READER']
    })
  },
  saveProductMetadata(id, data) {
    return http({
      method: 'POST',
      data,
      url: `/kcengine-ws-rest/products/${id}/metadata.json`,
      roles: ['ROLE_PRODUCT_MANAGER', 'ROLE_PRODUCT_READER']
    })
  }
}


// WEBPACK FOOTER //
// ./src/service/apis/Core.js